import { useCallback, useState } from "react";

import { reportRuntimeError } from "./reportRuntimeError";

/**
 * Holds a fatal error for the current page; pair with throwIfFatalError at render time.
 */
export function useFatalErrorState(): [Error | null, (error: unknown) => void] {
  const [fatalError, setFatalError] = useState<Error | null>(null);

  const failWithError = useCallback((error: unknown) => {
    const reportedError = reportRuntimeError(error);
    setFatalError(reportedError);
  }, []);

  return [fatalError, failWithError];
}

export function throwIfFatalError(fatalError: Error | null): void {
  if (fatalError !== null) {
    throw fatalError;
  }
}
